import { CheckDisbursementType } from './checks/CheckDisbursementType';
import { WireDisbursementType } from './wires/WireDisbursementType';
import { IDisbursementType } from './IDisbursementType';
import { ACHDisbursementType } from './ach/ACHDisbursementType';
import { useMemo } from 'react';
import { InternalTransferDisbursementType } from './internalTransfers/InternalTransferDisbursementType';
import { eDisbursementType } from 'types/order/escrow/eDisbursementType';
import { useHasManyPermissions } from '../../../../accessControl/hooks/useHasPermissions';
import { useHasFeatureFlag } from 'selectors/useHasFeatureFlag';
const disbursementTypes = [
  WireDisbursementType,
  CheckDisbursementType,
  ACHDisbursementType,
  InternalTransferDisbursementType,
];
const editPermissionList = disbursementTypes.map((t) => ({ allowedPermissions: [t.editPermission] }));
const readPermissionList = disbursementTypes.map((t) => ({ allowedPermissions: [t.readPermission] }));

// To remove the feature flags from this, we can remove the field 'enabled' from IDisbursementType
// then anywhere that complains can be treated as a true response.
export const useDisbursementTypes = (): IDisbursementType[] => {
  const edit = useHasManyPermissions(editPermissionList);
  const read = useHasManyPermissions(readPermissionList);
  const isZillowClosing = useHasFeatureFlag('pinecone.zillow-closing');
  const isSpruceWithZillowEnabled = useHasFeatureFlag('pinecone.spruce-with-zillow-closing');

  return useMemo(
    () =>
      disbursementTypes.map((item, index) => ({
        ...item,
        hasEditPermission: edit[index],
        hasReadPermission: read[index],
        create: (fee, order) => item.create(fee, order, isSpruceWithZillowEnabled, isZillowClosing),
      })),
    [edit, read, isSpruceWithZillowEnabled, isZillowClosing]
  );
};

export const useDisbursementType = (x: eDisbursementType) => {
  const allTypes = useDisbursementTypes();
  return allTypes.find((t) => t.type === x);
};
